import React from 'react';
import './Loading.scss';

export default () => (
  <div className="LoadingContainer">
    <div className="Loading">
      <div />
      <div />
      <div />
    </div>
  </div>
);
